import { useNavigate } from "react-router-dom";

import { ProgressSpinner } from "primereact/progressspinner";
import { useEffect, useRef, useState } from "react";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { InputText } from "primereact/inputtext";
import { getStoreLocalData, getUserData } from "../../../utils/localStorage";
import AdminMenu from "../../AdminMenu";
import { getBrandOldOrder } from "../../../services/BrandOldOrder/BrandOldOrder";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
const { innerWidth: width, innerHeight: height } = window;


const BrandOldOrder = () => {
  const navigate = useNavigate();

  const {brandProfileData } = getUserData();
  const { storeLocalData } = getStoreLocalData();

  let brandId = brandProfileData.id;

  const [brandOldOrdersData, setBrandOldOrdersData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [statusTotalData, setStatusTotalData] = useState([]);
  const [sumOfGrandTotal, setSumOfGrandTotal] = useState(0);
  const [sumOfOrderCount, setSumOfOrderCount] = useState(0);

  const [visible, setVisible] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [searchTypeToggle, setSearchTypeToggle] = useState(false);

  const fetchStoreOrders = (data) => {
    setLoading(true);
    getBrandOldOrder(brandId, data)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          const statusTotals = Res.reduce((acc, order) => {
            // Check if the status already exists in the accumulator
            const existingStatus = acc.find(
              (item) => item.status === order.status
            );

            if (existingStatus) {
              // If status exists, add the current order's grandTotal to the existing sum
              existingStatus.grandTotalSum += order.orderAmount;
              existingStatus.orderCount += 1; // Increment the order count
            } else {
              // If status does not exist, create a new object with the status, grandTotal, and order count
              acc.push({
                status: order.status,
                grandTotalSum: order.orderAmount,
                orderCount: 1,
              });
            }

            return acc;
          }, []);

          const totalGrandTotalSumData = statusTotals.reduce(
            (acc, item) => acc + item.grandTotalSum,
            0
          );
          const totalOrderCountData = statusTotals.reduce(
            (acc, item) => acc + item.orderCount,
            0
          );
          setStatusTotalData(statusTotals);
          setSumOfGrandTotal(totalGrandTotalSumData);
          setSumOfOrderCount(totalOrderCountData);
          setBrandOldOrdersData(Res);
          setLoading(false);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };

  useEffect(() => {
    const data = {
      brandId: brandId,
      limit: 100000,
    };
    fetchStoreOrders(data);
  }, []);

  const OrderStatusColors = {
    BOOKED: "#3EB3E1",
    INPROCESS: "#866CCE",
    PROCESSED: "#F5C43A",
    DELIVERED: "#09B4AA",
    DONE: "#55BD5A",
    CANCEL: "#FF6767",
    UNPROCESSED: "#5D53D8",
    OUT_FOR_DELIVERY: "#6EA4F5",
    DELAY_STATUS: "E89534",
    IN_WAREHOUSE: "#a906c2",
    DEFAULT: "#000",
  };

  const renderPaymentModeButtons = () => {
    return statusTotalData.map((item) => (
      <div
        key={item.status}
        style={{ backgroundColor: OrderStatusColors[item.status] }}
        className="px-3 py-2 border-round-md"
      >
        <p className="text-white text-lg font-bold uppercase">
          {item.orderCount} - {item.status.replace(/_/g, " ")} ({storeLocalData?.currencySymbol}{" "}
          {item.grandTotalSum.toFixed(0)})
        </p>
      </div>
    ));
  };

  const filterOrderInfoList = () => {
    return brandOldOrdersData.filter((item) => {
      const storeName = item.storeName?.toLowerCase();
      const customerMobile = item.customerMobile?.toLowerCase();
      const customerName = item.customerName?.toLowerCase();
      const invoiceNo = item.invoiceNo?.toLowerCase();
      const matchesStoreName = storeName?.includes(searchTerm.toLowerCase());
      const matchesSearchTermCustomerMobile = customerMobile?.includes(
        searchTerm.toLowerCase()
      );
      const matchesSearchTermCustomerName = customerName?.includes(
        searchTerm.toLowerCase()
      );
      const matchesSearchTermInvoiceNo = invoiceNo?.includes(
        searchTerm.toLowerCase()
      );
      return (
        matchesStoreName ||
        matchesSearchTermCustomerMobile ||
        matchesSearchTermCustomerName ||
        matchesSearchTermInvoiceNo
      );
    });
  };

  const filteredOrderInfoData = filterOrderInfoList();

  const handleClearSearch = () => {
    setSearchTerm("");
  };

  const formatDateLedger = (dateString) => {
    // const parsedDate = new Date(dateString.replace("Z", ""));
    const parsedDate = new Date(dateString)

    return parsedDate.toLocaleString("en-GB", {
      month: "2-digit",
      day: "2-digit",
      year: "2-digit",
      hour12: true,
    });
  };

  const Order = (
    <div >
      <span className="text-md ">
        Order ({storeLocalData?.currencySymbol})
      </span>
    </div>
  );

  const Paid = (
    <div >
      <span className="text-md ">
        Paid ({storeLocalData?.currencySymbol})
      </span>
    </div>
  );
  

  const RenderOldOrder = () => {

    return (
      <DataTable
        value={filteredOrderInfoData}
        paginator
        rows={10}
        rowsPerPageOptions={[10, 25, 50]}
        tableStyle={{ minWidth: "50rem" }}
        scrollable
        scrollHeight={height - 210}
      >
        <Column
          header="S No."
          style={{ width: "80px" }}
          body={(rowData, options) =>
            options.rowIndex + 1}
        ></Column>
        <Column
          field="invoiceNo"
          header="Invoice No"
           
        ></Column>
         <Column
        field="dateOfOrder"
        header="Date Of Order"
        body={(rowData) => formatDateLedger(rowData.dateOfOrder)}
         
      />
      <Column
        field="dateOfDelivery"
        header="Delivery Date"
        body={(rowData) => formatDateLedger(rowData.dateOfDelivery)}
         
      />
        <Column
          field="customerName"
          header="Customer Name"
           
        ></Column>
        <Column
          field="customerMobile"
          header="Mobile No."
           
        ></Column>
        <Column
          field="status"
          header="Status"
           
        ></Column>
        <Column
          field="orderAmount"
          header={Order}
           
        ></Column>
        <Column
          field="paidAmount"
          header={Paid}
           
        ></Column>
        <Column
          field="storeName"
          header="Store Name"
           
        ></Column>
      </DataTable>
    );
  };
  return (
    <div className="flex-1">
      <div
        className="h-3rem surface-0 sticky z-2 top-0 flex justify-content-center align-items-center"
        style={{
          "--surface-0": "#1752AA",
        }}
      >
        <div className="flex-1 flex ml-3 mr-3">
          <div className="flex-1 flex ">
            <div className="ml-3 flex justify-content-center align-items-center">
              <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
              <i
                  className="pi pi-angle-left"
                  onClick={() => navigate("/")}
                  style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}
                ></i>
              </div>
            </div>
            <div className="flex-1 ml-5">
              <p className="text-white text-2xl font-bold uppercase">
                Old Order
              </p>
            </div>
          </div>

          <div
            className="flex justify-content-center align-items-center cursor-pointer"
            onClick={() => setVisible(true)}
          >
            <i
              className="pi pi-bars"
              style={{ fontSize: "27px", marginRight: 30, color: "#fff" }}
            ></i>
          </div>
        </div>
      </div>

      <div className="mx-4 mt-3">
        <div
          className="flex gap-3 mb-3 pb-1 new-scroll-bar"
          style={{
            overflowX: "auto",
            whiteSpace: "nowrap",
          }}
        >
          <div
            style={{ backgroundColor: "#2B70D7" }}
            className="px-3 py-2 border-round-md"
          >
            <p className="text-white text-lg font-bold uppercase">
              {sumOfOrderCount} - All ({storeLocalData?.currencySymbol} {sumOfGrandTotal.toFixed(0)})
            </p>
          </div>

          {renderPaymentModeButtons()}
        </div>
      </div>
      <div className="  mt-3">
        <div className="my-2 mx-5 flex flex-1">
          <div className="flex-1">
            <IconField iconPosition="left" className="flex flex-1">
              <InputIcon className="pi pi-search text-xl"> </InputIcon>
              <InputText
                placeholder={"Search Order"}
                value={searchTerm}
                keyboardType={"default"}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="text-xl flex flex-1 py-1 px-5"
                style={{ borderRadius: 30 }}
              />
            </IconField>
          </div>

          {searchTerm && (
            <div
              className="flex justify-content-center align-items-center mx-2 cursor-pointer"
              onClick={handleClearSearch}
            >
              <div>
                <p className="text-4xl font-bold " style={{ color: "red" }}>
                  X
                </p>
              </div>
            </div>
          )}
        </div>

        {loading ? (
          <div style={{ flex: 1 }}>
            <div className="text-center">
              <ProgressSpinner
                style={{ width: "70px", height: "70px" }}
                strokeWidth="4"
                fill="var(--surface-ground)"
                animationDuration="2s"
              />
            </div>
          </div>
        ) : filteredOrderInfoData?.length > 0 ? (
          <div className="mx-4">

          {RenderOldOrder()}
          </div>
        ) : (
          <div className="flex justify-content-center align-items-center">
            <p
              className="text-xl font-semi-bold"
            >
              No Order Found
            </p>
          </div>
        )}
      </div>
      <AdminMenu setVisible={setVisible} visible={visible} />
    </div>
  );
};

export default BrandOldOrder;
